import { Component } from '@angular/core';

@Component({
	templateUrl: 'host.page.html',
	styleUrls: ['host.page.scss']
})
export class HostPage {
}
